import { api } from '@qirapagos/lib/config/api'
import { insertKeyEndpoint } from './utils'
const TIME_ZONE = 'serverDateTime'

export const getServerTime = (token: string | null, keyEndpoints: string) =>
  api.get(
    insertKeyEndpoint(TIME_ZONE, keyEndpoints),
    {},
    { headers: { token } }
  )
